const { CUSTOM_PROPERTY_PREFIX } = require("./constants.cjs")
const isHex = stringToTest => {
  const regex = new RegExp("^#([A-Fa-f0-9]{6})")
  return regex.test(stringToTest)
}
const getRGBColorValue = (hexValue, name) => {
  if (!isHex(hexValue)) {
    throw Error(`${hexValue} is not a valid hex value. Check value of color token ${name}`)
  }
  const r = parseInt(hexValue.slice(1, 3), 16)
  const g = parseInt(hexValue.slice(3, 5), 16)
  const b = parseInt(hexValue.slice(5, 7), 16)
  return { r, g, b }
}

const getRootElColorCustomProperties = (tokens, prefix = "") => {
  // One entry would look look like {'--color-gray-200': '245 245 245'}
  let result = {}
  const tokenEntries = Object.entries(tokens)
  tokenEntries.forEach(([name, config]) => {
    if (config.value) {
      const customPropertyName = `${CUSTOM_PROPERTY_PREFIX}${prefix}${name}` // For example, --color-gray-200
      const { r, g, b } = getRGBColorValue(config.value, name)
      result[customPropertyName] = `${r} ${g} ${b}`
    } else {
      result = Object.assign(
        Object.assign({}, result),
        getRootElColorCustomProperties(config, `${prefix}${name}-`),
      )
    }
  })
  return result
}

module.exports = {
  getRootElColorCustomProperties,
}
